package com.downdogapp.client.views.menu

import com.downdogapp.*
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Companion.vh
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.controllers.menu.LanguageViewController
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.StructuredRow.Companion.structuredRow

actual fun createLanguageView(
  selectedIndex: Int,
  controller: LanguageViewController
): LanguageView = object : TopLevelView(), LanguageView {

  override var selectedIndex = selectedIndex; private set

  private var table: TableView

  override val root =
    controllerView {
      bg = background(true)
      fg = foreground(true) {
        centeredColumnView {
          pageHeader(
            title = Strings.LANGUAGE,
            onBackClicked = controller::onBackClicked
          )

          table = tableView(::getContents, maskBottomGradient = true) {
            maxHeight = vh(55)
          }

          roundedTextButton(
            text = Strings.SELECT,
            marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
            clickFn = controller::onSubmitClicked
          ) {
            marginTop = px(6)
          }
        }
      }
    }

  private fun getContents() = TableContents(
    rows = MANIFEST.languageOptions.mapIndexed { index, option ->
      val isSelected = index == this.selectedIndex
      structuredRow(
        height = DEFAULT_ROW_HEIGHT_PX,
        allowSeparator = !isSelected,
        clickFn = {
          this.selectedIndex = index
          table.refreshContents()
        }
      ) {
        leftTextContent(option.label)

        if (isSelected) {
          highlight()
          rightCheckmark()
        }
      }
    },
    separator = fullWidthSeparator
  )
}
